module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "padding-top": "10px",
      "margin-bottom": "-12px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "用户 / 手机号 / 名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList(1)
      }
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "类型",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue),
      callback: function($$v) {
        _vm.typeValue = $$v
      },
      expression: "typeValue"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "状态",
      "clearable": ""
    },
    model: {
      value: (_vm.typeValue2),
      callback: function($$v) {
        _vm.typeValue2 = $$v
      },
      expression: "typeValue2"
    }
  }, _vm._l((_vm.types2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.getProList(1)
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "medium",
      "disabled": _vm.ProductSelection.length == 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.batch(1)
      }
    }
  }, [_vm._v("批量分配")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "medium",
      "disabled": _vm.ProductSelection.length == 0
    },
    on: {
      "click": function($event) {
        _vm.visibleDispatch = true
      }
    }
  }, [_vm._v("分配部门")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.proList,
      "highlight-current-row": "",
      "header-cell-style": _vm.getRowClass,
      "row-key": function (row) { return row.id; }
    },
    on: {
      "sort-change": _vm.handleSortChange,
      "selection-change": _vm.handleProductSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "reserve-selection": true,
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "label": "序号",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "200",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productname",
      "label": "名称",
      "min-width": "220",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户",
      "min-width": "110",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.name || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.phone || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "产品所属部门",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.deptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userdeptname",
      "label": "用户所属部门",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.userdeptname || '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typename",
      "label": "类型",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usingstatusname",
      "label": "状态",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "duetime1",
      "label": "到期时间",
      "min-width": "120",
      "sortable": "custom",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    staticStyle: {
      "text-algin": "center"
    },
    attrs: {
      "label": "操作",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "operate"
        }, [_c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "分配用户授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconclone-more",
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        })]), _vm._v(" "), (!scope.row.delShow) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "撤销用户授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconundo",
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.deptid) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": "撤销部门授权",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "dnnfont iconundo2",
          staticStyle: {
            "font-size": "17px"
          },
          on: {
            "click": function($event) {
              return _vm.handleDelDepart(scope.$index, scope.row)
            }
          }
        })]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "margin-top": "10px",
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "sizes, prev, pager, next",
      "page-sizes": [3, 10, 20, 30, 50, 100],
      "current-page": _vm.pageNumber,
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), (_vm.editFormVisible) ? _c('el-dialog', {
    staticClass: "model-edit",
    attrs: {
      "title": "分配用户",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.souchs2
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeSouch2
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  }, _vm._l((_vm.optionsSouch2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disSouch2),
      expression: "disSouch2"
    }],
    staticStyle: {
      "width": "200px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUser(1)
      }
    },
    model: {
      value: (_vm.proName2),
      callback: function($$v) {
        _vm.proName2 = $$v
      },
      expression: "proName2"
    }
  }), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fpTypes2),
      expression: "fpTypes2"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.fpType),
      callback: function($$v) {
        _vm.fpType = $$v
      },
      expression: "fpType"
    }
  }, _vm._l((_vm.fpTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.showDepart) ? _c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "部门"
    },
    model: {
      value: (_vm.deptid),
      callback: function($$v) {
        _vm.deptid = $$v
      },
      expression: "deptid"
    }
  }, _vm._l((_vm.departList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getUser(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _vm._l((_vm.dynamicTags2), function(tag2) {
    return _c('el-tag', {
      key: tag2,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose2(tag2)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag2) + "\n        ")])
  }), _vm._v(" "), (_vm.dynamicTags2 != '') ? _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.delTags2
    }
  }, [_vm._v("清除标签")]) : _vm._e()], 2), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.userLoading),
      expression: "userLoading"
    }],
    ref: "userList",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.userList,
      "highlight-current-row": "",
      "height": "400",
      "row-key": function (row) { return row.id; },
      "header-cell-style": _vm.getRowClass
    },
    on: {
      "select": _vm.selectTable,
      "sort-change": _vm.handleSortChange2,
      "current-change": _vm.handleSelectionChange,
      "selection-change": _vm.handleUserSelectionChange
    }
  }, [(_vm.batchType == 0) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.checked),
            expression: "scope.row.checked"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(scope.row.checked) ? _vm._i(scope.row.checked, null) > -1 : (scope.row.checked)
          },
          on: {
            "change": [function($event) {
              var $$a = scope.row.checked,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(scope.row, "checked", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(scope.row, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(scope.row, "checked", $$c)
              }
            }, _vm.changeFun]
          }
        })]
      }
    }], null, false, 19795969)
  }) : _c('el-table-column', {
    attrs: {
      "reserve-selection": true,
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "min-width": "130",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deptname",
      "label": "部门",
      "min-width": "200",
      "sortable": "deptname",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.deptname ? scope.row.deptname : '-') + "\n          ")]
      }
    }], null, false, 2631811957)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invitestatusname",
      "label": "状态",
      "min-width": "180",
      "show-overflow-tooltip": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,sizes, prev, pager, next",
      "current-page": _vm.pageNumber2,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize2,
      "total": _vm.total2
    },
    on: {
      "current-change": _vm.handleCurrentChange2,
      "size-change": _vm.handleSizeChange2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.batchType == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit(0)
      }
    }
  }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (_vm.batchType == 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit(1)
      }
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.visibleDispatch) ? _c('el-dialog', {
    staticClass: "model-dispatch",
    attrs: {
      "title": "分配部门",
      "visible": _vm.visibleDispatch,
      "close-on-click-modal": false,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.visibleDispatch = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-form', {
    ref: "dispatchForm",
    attrs: {
      "model": _vm.dispatchForm,
      "rules": _vm.dispatchRules,
      "hide-required-asterisk": "",
      "label-position": "left"
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px",
      "color": "#666",
      "font-size": "14px"
    },
    attrs: {
      "span": 24
    }
  }, [_vm._v("\n            已选择" + _vm._s(_vm.ProductSelection.length) + "个产品授权，请选择所属部门\n          ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "deptid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.dispatchForm.deptid),
      callback: function($$v) {
        _vm.$set(_vm.dispatchForm, "deptid", $$v)
      },
      expression: "dispatchForm.deptid"
    }
  }, _vm._l((_vm.departList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.deptname,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handerCloseDispatch.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.confirmDispatchLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handerSubmitDispatch.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77dec7e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/companys/WeProduct.vue
// module id = 1811
// module chunks = 9